// extracted by mini-css-extract-plugin
export var loadingSpinner = "_v-0";